var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPin = function SvgIconPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.816 3.571a1.95 1.95 0 0 1 2.76 0l9.853 9.854a1.95 1.95 0 0 1 0 2.758L26.78 25.83l-1.922 7.692c-.367 1.47-2.2 1.977-3.271.906l-6.623-6.623-7.62 7.62a1.96 1.96 0 0 1-2.77-2.77l7.62-7.62-6.623-6.623c-1.072-1.072-.564-2.904.907-3.271l7.69-1.922z"
  })));
};
export default SvgIconPin;